import gql from 'graphql-tag'

export const ME_QUERY = gql`
query MeQuery {
  me {
    id
    userType
    username
  }
}
`



// WEBPACK FOOTER //
// ./src/queries/ME_QUERY.ts